export default {
  ancient_author: [
    {
      id: 'scheda',
      label: 'tabs#ancient_author_scheda'
    },
    {
      id: 'occurrences',
      label: 'tabs#ancient_author_occurrences'
    },
    {
      id: 'authorWorks',
      label: 'tabs#ancient_author_works'
    },
  ]
};
